import React, { Component } from 'react';
import ThemeCardThemeStatus from './ThemeCardThemeStatus';
import LinkedContainer from './theme-card/LinkedContainer';
import Container from './theme-card/Container';
import ParentName from './theme-card/ParentName';
import ThemeName from './theme-card/ThemeName';
import remToPixels from '../utils/remToPixels';
import ThemeLabelContainer from './theme-card/ThemeLabelContainer';
import RenderOnMobile from "./responsive/RenderOnMobile";
import RenderOnTablet from "./responsive/RenderOnTablet";
import OutletOnlyLabel from "./OutletOnlyLabel";

function generateLink(theme) {
  return theme.parentType === 'collections'
    ? `/seasonal/${theme.parentId}/themes/${theme.themeId}`
    : `/timeless/${theme.parentId}/themes/${theme.themeId}`
}

class HomeThemeCard extends Component {
  static defaultProps = {
    theme: null,
    status: null,
  };

  render() {
    const { theme, related = false, fullWidth = false, ...props } = this.props;
    const isRelatedTheme = related ? 1 : 0;
    const cover = `${theme.themeCover.replace('0x0', `${remToPixels(22)}x${remToPixels(16)}`)}?scalemode=centered`;

    return (
      <LinkedContainer {...props} related={isRelatedTheme} to={generateLink(theme)}>
        <Container cover={cover} related={isRelatedTheme} fullWidth={fullWidth}>
          <ThemeLabelContainer theme={theme} width="40%" />
          <RenderOnMobile>
            <div>
              <ParentName related={isRelatedTheme}>{theme.parentName}</ParentName>
              <ThemeName related={isRelatedTheme}>{theme.themeName}</ThemeName>
            </div>
            <ThemeCardThemeStatus light small status={this.props.status} />
            {theme.visibleOnlyForOutlets && <OutletOnlyLabel key="outlet_only" />}
          </RenderOnMobile>

          <RenderOnTablet>
            <ParentName related={isRelatedTheme}>{theme.parentName}</ParentName>
            <ThemeCardThemeStatus light small={related} status={this.props.status} style={{ marginBottom: '1rem', }} />
            <ThemeName related={isRelatedTheme}>{theme.themeName}</ThemeName>
          </RenderOnTablet>
        </Container>
      </LinkedContainer>
    );
  }
}

export default HomeThemeCard;
